import { FormControl, FormGroup, Validators } from '@angular/forms';

export class AddressUtilForm {
  static createForm(): FormGroup {
    return new FormGroup({
      addressLabel: new FormControl(null),
      addressLine: new FormControl(null),
      streetName: new FormControl(null),
      streetNumber: new FormControl(null),
      block: new FormControl(null),
      building: new FormControl(null),
      floor: new FormControl(null),
      apartment: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null),
      postalCode: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      pointDTO: new FormControl(null),
      details: new FormControl(null),
      owner: new FormControl(null),
      uuid: new FormControl(null),
      deleted: new FormControl(null),
      addressTypeValue: new FormControl(null, [Validators.required]),
      visibilityType: new FormControl(null),
    });
  }
}

